import { Input, InputGroup, InputGroupProps, InputProps } from '@chakra-ui/react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

interface MemberNumberOrEmailInputProps {
    formControlRef?: UseFormRegisterReturn<string>;
    inputGroupProps?: InputGroupProps;
    inputProps?: InputProps;
}

const MemberNumberOrEmailInput = (props: MemberNumberOrEmailInputProps) => {
    const { inputProps, inputGroupProps, formControlRef } = props;
    const intl = useIntl();

    return (
        <InputGroup {...inputGroupProps}>
            <Input
                placeholder={intl.formatMessage({ id: 'member-number-or-email-placeholder' })}
                {...formControlRef}
                {...inputProps}
            />
        </InputGroup>
    );
};

export default MemberNumberOrEmailInput;
